/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnShared } from './en-shared';
import { JoinEntityDto } from './join-entity-dto';
import { ProtocolPathologyDto } from './protocol-pathology-dto';
import { ProtocolSessionDto } from './protocol-session-dto';
 /**
 *
 *
 * @export
 * @interface ProtocolDto
 */
export interface ProtocolDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof ProtocolDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ProtocolDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ProtocolDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof ProtocolDto
     */
    deleted: string | null;

    /**
     * @type {string}
     * @memberof ProtocolDto
     */
    name: string;

    /**
     * @type {string}
     * @memberof ProtocolDto
     */
    description: string | null;

    /**
     * @type {EnShared}
     * @memberof ProtocolDto
     */
    shared: EnShared;

    /**
     * @type {JoinEntityDto}
     * @memberof ProtocolDto
     */
    client: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof ProtocolDto
     */
    creator: JoinEntityDto | null;

    /**
     * @type {Array<ProtocolSessionDto>}
     * @memberof ProtocolDto
     */
    sessions: Array<ProtocolSessionDto>;

    /**
     * @type {Array<ProtocolPathologyDto>}
     * @memberof ProtocolDto
     */
    pathologies: Array<ProtocolPathologyDto>;
}
